import { AfterpayGreyRegular } from '@/icons/web/regular/afterpay-grey'
import { ApplePayRegular } from '@/icons/web/regular/apple-pay'
import { MastercardGreyRegular } from '@/icons/web/regular/mastercard-grey'
import { PaypalGreyRegular } from '@/icons/web/regular/paypal-grey'
import { Stack } from '@mui/material'
import { VisaGreyRegular } from '@/icons/web/regular/visa-grey'
import { AmexGreyRegular } from '@/icons/web/regular/amex-grey'
import { GooglePayGrey } from '@/icons/web/regular/google-pay-grey'
export const CartSupportedPayment = ({ small }: { small?: boolean }) => {
  const smallBlock = (
    <div className='m-2'>
      <div className='text-center font-bold'>
        Secure ways to pay at checkout
      </div>
      <Stack
        direction='row'
        justifyContent='center'
        alignItems='center'
        style={{ marginTop: 0 }}
      >
        <MastercardGreyRegular width={100} style={{ margin: '0px 15px 0px' }} />
        <VisaGreyRegular
          height={50}
          width={50}
          style={{ margin: '0px 20px 0px -20px' }}
        />
        <AmexGreyRegular
          height={30}
          width={30}
          style={{ margin: '0px 20px 0px 0px' }}
        />
        <ApplePayRegular height={30} width={50} />
        <PaypalGreyRegular
          height={50}
          width={70}
          style={{ margin: '0px -13px 0px 20px' }}
        />
        <AfterpayGreyRegular
          height={70}
          style={{ margin: '0px -20px 0px 0px' }}
        />
        <GooglePayGrey
          height={50}
          width={70}
          style={{ margin: '0px 20px 2px 0px' }}
        />
      </Stack>
    </div>
  )

  const largeBlock = (
    <div className='mt-6'>
      <div className='mb-4 text-center'>Secure ways to pay at checkout</div>
      <Stack
        direction='row'
        justifyContent='center'
        alignItems='center'
        style={{ marginTop: 0 }}
      >
        <MastercardGreyRegular
          width={100}
          style={{ margin: '0px 15px 0px -30px' }}
        />
        <VisaGreyRegular
          height={50}
          width={50}
          style={{ margin: '0px 20px 0px -20px' }}
        />
        <AmexGreyRegular
          height={30}
          width={30}
          style={{ margin: '0px 20px 0px 0px' }}
        />
        <ApplePayRegular height={30} width={50} />
      </Stack>
      <Stack
        direction='row'
        justifyContent='center'
        alignItems='center'
        style={{ marginTop: 0 }}
      >
        <PaypalGreyRegular
          height={50}
          width={70}
          style={{ margin: '0px -13px 0px 20px' }}
        />
        <AfterpayGreyRegular
          height={70}
          style={{ margin: '0px -20px 0px 0px' }}
        />
        <GooglePayGrey
          height={50}
          width={70}
          style={{ margin: '0px 20px 2px 0px' }}
        />
      </Stack>
    </div>
  )

  return small ? smallBlock : largeBlock
}
